import { Delegation } from "../Model/Delegation";


export class GetDelegationList {
    constructor(
        total,
        offset,
        limit,
        records,
    ) {
        this.total = total;
        this.offset = offset;
        this.limit = limit;
        this.records = records;
    }
    static createFromResponseData(data) {
        return new GetDelegationList(
            data.total,
            data.offset,
            data.limit,
            data.records.map((record) => {
                return Delegation.createFromResponseData(record);
            }),
        );
    }
};